import { Action } from 'redux';

export const DISCARD_HISTORY = 'INTEGRATED_DRAWING_DISCARD_HISTORY';

interface DiscardHistoryAction extends Action {
  type: typeof DISCARD_HISTORY;
  key: string;
}

export type IntegratedDrawingAction =  DiscardHistoryAction;

export const discardHistory = (key: string): DiscardHistoryAction => (
  { key, type: DISCARD_HISTORY }
);

export const isIntegratedDrawingAction = (action: Action): action is IntegratedDrawingAction => {
  switch (action.type) {
    case DISCARD_HISTORY:
      return true;
    default:
      return false;
  }
};
